/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
const throttled = {};

const middleware = store => next => action => {
  
  const time = action.meta && action.meta.throttle;

  if (!time) return next(action);

  if (throttled[action.type]) return; // Just ignore the action if its already throttled

  throttled[action.type] = true;

  setTimeout(() => (throttled[action.type] = false), time);

  return next(action);
};

export default middleware;
